<template>
  <svg
    id="Home-Button-3--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <desc>Home Button 3 Streamline Icon: https://streamlinehq.com</desc>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12.6 1.2c-0.3556 -0.266667 -0.8444 -0.266667 -1.2 0l-10 7.5c-0.25181 0.18885 -0.4 0.48524 -0.4 0.8V22c0 0.5523 0.44772 1 1 1h6c0.55228 0 1 -0.4477 1 -1v-5c0 -1.6569 1.3431 -3 3 -3s3 1.3431 3 3v5c0 0.5523 0.4477 1 1 1h6c0.5523 0 1 -0.4477 1 -1V9.5c0 -0.31476 -0.1482 -0.61115 -0.4 -0.8l-10 -7.5Z"
      clip-rule="evenodd"
      stroke-width="1"
    />
  </svg>
</template>
